export const careersPath = '/careers'

export const links = [
  { title: 'About', link: '/about' },
  { title: 'Services', link: '/services' },
  { title: 'Blog', link: '/blog' },
  { title: 'Portfolio', link: '/portfolio' },
  { title: 'Careers', link: careersPath },
]

export const HamburgerBarsPosition = ['first', 'second', 'third']

export const emergencyBannerColorKey = 'EMERGENCY_BANNER_COLOR'
export const emergencyBannerEnabledKey = 'EMERGENCY_BANNER_ENABLED'
export const emergencyBannerMessageKey = 'EMERGENCY_BANNER_MESSAGE'
export const showWeAreHiringButtonKey = 'SHOW_WE_ARE_HIRING_BUTTON'
